import React from 'react';
import { Namespace } from '../../../../../translation/namespace';
import {
  Input,
  Row,
  Textarea,
  TextAreaParam,
  TextParam,
  UrlParam,
  DateRangeWithIsAllDaySwitch,
} from '../../../../../_lib/Form2';
import { useSonTranslation } from '../../../../../translation/useSonTranslation';
import { PrefillableTextInput } from '../../../../../_lib/Form2/elements/PrefillableTextInput/PrefillableTextInput';
import { DateRangeParam } from '../../../../../_lib/Form2/types/DateRangeParam';

type EventFormTemplateProps = {
  dateRangeParam?: DateRangeParam<'daterange'>;
  locationParam?: TextParam<'location'>;
  additionalInfoParam?: TextAreaParam<'additionalInfo'>;
  conferenceRoomUrlParam?: UrlParam<'conferenceRoomUrl'>;
};

export function EventFormTemplate({
  dateRangeParam,
  locationParam,
  additionalInfoParam,
  conferenceRoomUrlParam,
}: EventFormTemplateProps) {
  const { t } = useSonTranslation('CreatePage');

  return (
    <>
      {dateRangeParam?.name && (
        <DateRangeWithIsAllDaySwitch
          dateRangeParam={dateRangeParam}
          labelSwitch={t(`${Namespace.PageManagement}:views.create-page-general.inputs.daterange.labelIsAllDay`)}
          labelStart={t(`${Namespace.PageManagement}:views.create-page-general.inputs.daterange.labelStartDate`)}
          labelEnd={t(`${Namespace.PageManagement}:views.create-page-general.inputs.daterange.labelEndDate`)}
        />
      )}
      {locationParam?.name && (
        <Row>
          <Input
            label={t(`${Namespace.PageManagement}:views.create-page-general.inputs.${locationParam.name}.label`)}
            param={locationParam}
          />
        </Row>
      )}
      {additionalInfoParam?.name && (
        <Row>
          <Textarea
            label={t(`${Namespace.PageManagement}:views.create-page-general.inputs.${additionalInfoParam.name}.label`)}
            param={additionalInfoParam}
          />
        </Row>
      )}
      {conferenceRoomUrlParam?.name && (
        <Row>
          <PrefillableTextInput
            label={
              t(`${Namespace.PageManagement}:views.create-page-general.inputs.${conferenceRoomUrlParam.name}.label`)
            }
            buttonLabel={
              t(`${Namespace.PageManagement}:views.create-page-general.inputs.${conferenceRoomUrlParam.name}.button`)
            }
            preparedValue={conferenceRoomUrlParam.preparedValue}
            // removing prepared value from params
            param={Object.entries(conferenceRoomUrlParam)
              .reduce((accumulator, currentValue) => {
                return {
                  ...accumulator,
                  ...(currentValue[0] !== 'preparedValue'
                    ? {
                        [currentValue[0]]: currentValue[1],
                      }
                    : undefined),
                };
              }, {} as UrlParam<'conferenceRoomUrl'>)}
          />
        </Row>
      )}
    </>
  );
}
